/**
* @file 运营中心-虚拟订单
* */
<template>
  <div id="virtualOrder">
    <custom-table
      ref="customTable"
      :customOptions="customOptions"
      :columns="columns"
      addText="添加计划"
      @addFn="actionFn({ type: 'add' })"
      labelWidth="135"
      style="height: 100%"
    >
      <template slot="search-bottom">
        <div class="blueInfo">
          <p>
            *
            每个城市每日仅可有1个待投放/投放中的计划。仅当日已完成投放才可补充新的投放计划
          </p>
          <p>* 虚拟订单无法抢单成功，司机抢单后即自动取消订单</p>
        </div>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" minWidth="100" fixed="right" align="center">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="actionFn({ type: 'copy', row: row })"
              >复制</el-button
            >
            <el-button
              type="text"
              style="color: red"
              @click="actionFn({ type: 'delete', row: row })"
              >删除
            </el-button>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'status'">
          <el-tag size="mini" :type="row[item.prop] == 0 ? 'danger' : row[item.prop] == 1 ? '' : 'success'">{{ row[item.prop] | filterStatus }}</el-tag>
        </template>
        <template v-else-if="item.prop === 'withinCityNum'">
          <span>
            计划投放: {{ row.withinCityNum * ($utils.daysBetweenDates($utils.timeFn(row.createdDateStart), $utils.timeFn(row.createdDateEnd))) }} 
          </span>
          <span> / </span>
          <span>累计投放: {{ row.putWithinCityNum }} </span>
          <span> / </span>
          <span>
            累计消耗: 
            <span :style="{ color: row.putWithinCityNum > 0 && (row.consumeWithinCityNum / row.putWithinCityNum) >= 0.8 ? '#FF0000' : '#66CC00' }">{{ row.consumeWithinCityNum }}</span>
          </span>
        </template>
        <template v-else-if="item.prop === 'betweenCityNum'">
          <span>计划投放: {{ row.betweenCityNum * ($utils.daysBetweenDates($utils.timeFn(row.createdDateStart), $utils.timeFn(row.createdDateEnd))) }} </span>
          <span> / </span>
          <span>累计投放: {{ row.putBetweenCityNum }} </span>
          <span> / </span>
          <span>
            累计消耗: 
            <span :style="{ color: row.putBetweenCityNum > 0 && (row.consumeBetweenCityNum / row.putBetweenCityNum) >= 0.8 ? '#FF0000' : '#66CC00' }">{{ row.consumeBetweenCityNum }}</span>
          </span>
        </template>
        <template v-else-if="item.prop === 'createdDateEnd'">
          <span>{{ row.createdDateStart | filterTime('YYYY/MM/DD') }}</span>
          <span> ~ </span>
          <span>{{ row.createdDateEnd | filterTime('YYYY/MM/DD') }}</span>
        </template>
        <template v-else-if="item.prop === 'created'">
          <span>{{ row.created | filterTime }}</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <el-dialog
      title="添加投放计划"
      :before-close="handClose"
      :visible.sync="showCancel"
      width="500px"
    >
      <el-form :model="form" ref="form" label-width="100px" :rules="rules">
        <el-form-item label="投放城市" prop="cityCode">
          <el-select v-model="form.cityCode" placeholder="请选择" clearable filterable>
            <el-option
              v-for="item in cityList"
              :key="item.id"
              :label="item.cityName"
              :value="item.gaodeCityCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放日期" prop="time">
          <el-date-picker
            v-model="form.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            :picker-options="pickerOptions"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="市内路线" prop="withinCityNum">
          <el-input
            v-model="form.withinCityNum"
            placeholder="请输入每日投放订单数量"
            :maxlength="5"
            @input="inputChange($event, 'withinCityNum')"
          >
            <template slot="append">单</template>
          </el-input>
        </el-form-item>
        <el-form-item label="城际路线" prop="betweenCityNum">
          <el-input
            v-model="form.betweenCityNum"
            placeholder="请输入每日投放订单数量"
            :maxlength="5"
            @input="inputChange($event, 'betweenCityNum')"
          >
            <template slot="append">单</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handClose">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "virtualOrder",
  data() {
    return {
      loading: false,
      // 配置项
    customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/order/hitchRide/virtual",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "select",
            field: "cityCode",
            name: "投放城市",
            value: "",
            option: [],
            clearable: true,
            filterable: true,
          },
          {
            type: "select",
            field: "status",
            name: "状态",
            value: "",
            option: this.$const.PLACEMENTSTATUS,
            clearable: true,
          },
        ],
    },
      // 表头
      columns: [
        { prop: "city", label: "投放城市" },
        { prop: "status", label: "计划状态" },
        { prop: "withinCityNum", label: "市内路线",minWidth: 220 },
        { prop: "betweenCityNum", label: "城际路线",minWidth: 220  },
        { prop: "createdDateEnd", label: "投放时间",minWidth: 120  },
        { prop: "created", label: "创建时间" },
      ],
      showCancel: false,
      form: {
        cityCode: "",
        time: "",
        withinCityNum: "",
        betweenCityNum: "",
      },
      rules: {
        cityCode: [{ required: true, message: "请选择城市", trigger: "change" }],
        time: [{ required: true, message: "请选择时间", trigger: "change" }],
        withinCityNum: [
          { required: true, message: "请输入市内路线", trigger: "blur" },
        ],
        betweenCityNum: [
          { required: true, message: "请输入城际路线", trigger: "blur" },
        ],
      },
      selectDate: "",
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = 6 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return (
              time.getTime() < Date.now() ||
              time.getTime() < minTime ||
              time.getTime() > maxTime
            );
          } else {
            return time.getTime() < Date.now();
          }
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      cityList: "cityListGetter",
    }),
  },
  mounted() {},
  watch: {
    cityList: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.customOptions.search[0].option = val;
        }
      }
    }
  },

  methods: {
    actionFn({ type, row }) {
      switch (type) {
        case "add":
          this.showCancel = true;
          break;
        case "copy":
          this.form = {
            cityCode: row.cityCode,
            city: row.city,
            withinCityNum: row.withinCityNum,
            betweenCityNum: row.betweenCityNum,
          };
          this.showCancel = true;
          break;
        case "delete":
          this.rowData = row;
          this.$confirm("确定删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            const url = `/api/v1/manage/order/hitchRide/virtual?id=${row.id}`;
            const { code } = await this.$axios.delete(url);
            if (code === 1) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handClose()
              this.$refs.customTable.listFn()
            }
          });
          break;
      }
    },
    inputChange(value, key) {
      this.form[key] = value.replace(/[^\d]/g, "");
      this.form[key] = +this.form[key] > 500 ? 500 : this.form[key];
      this.form[key] =
        this.form[key] !== "" && +this.form[key] < 1 ? 1 : this.form[key];
    },
    handClose() {
      this.form = {};
      this.showCancel = false;
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const url = "/api/v1/manage/order/hitchRide/virtual";
          const params = this.$utils.deepCopyFn(this.form)
          params.createdDateStart = Date.parse(new Date(params.time[0])) / 1000;
          params.createdDateEnd = Date.parse(new Date(params.time[1])) / 1000;
          const cityItem = this.cityList.find(item => item.gaodeCityCode === params.cityCode);
          params.city = cityItem ? cityItem.cityName : '';
          this.loading = true;
          try {
            const {code} = await this.$axios.post(url, params)
            if(code === 1) {
              this.$message.success("提交成功");
              this.handClose();
              this.$refs.customTable.listFn()
            }
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>
